import Vue from 'vue'
import { isInternalUrl, toRelativeUrl } from '@/utils/internalUrl'

export default Vue.extend({
  methods: {
    // Absolute links to this shop count as relative too — the CMS stores them
    // with the production origin. Pair every `isRelativeUrl` check with
    // `toRelativeUrl` on the bound value: vue-router rejects a full URL as `to`.
    isRelativeUrl (url: string | null | undefined): boolean {
      return isInternalUrl(url)
    },
    toRelativeUrl (url: string | null | undefined): string {
      return toRelativeUrl(url)
    }
  }
})
